import tlds from '@mymyResources/tld-list';

/**
 * EMAIL ADDRESS VALIDATOR + TOP LEVEL DOMAIN VALIDATION
 *
 * @param address
 * @returns {boolean}
 */
export default address => {
    let parts = address.split('.');
    let key = '', tldLevel = -1;

    for (let i = parts.length - 1; i >= 0; i--) {
        let part = parts[i];
        key = key ? part + "." + key : part;

        if (tlds[key]) {
            tldLevel = tlds[key];
        }
    }

    if (parts.length <= tldLevel || tldLevel === -1) {
        return false;
    }

    if (! parts.slice(-tldLevel).join('.')) {
        return false;
    }

    return true;
};